/**
 * Sleep for "ms" milliseconds.
 *
 * @param {*} ms
 * @returns
 */
export const sleep = (ms: number) => {
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
};